<template lang="pug">
.notification-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：タイトル
    template(#cell(title)="row")
      span.detail-link.link-text(@click="onNotification(row.item)") {{ row.item.title }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 未読お知らせテーブルコンポーネント
 */
@Component({})
export default class UnReadNotificationTable extends Vue {
  /** お知らせ各行の情報 */
  @Prop({ required: true })
  value!: Array<UnReadNotificationTableItem>;

  /** お知らせ列名 */
  fields: Array<UnReadNotificationTableField> = [
    { key: "date", label: "日付", sortable: false, sortDirection: "desc", class: "date text-center" },
    { key: "title", label: "タイトル", sortable: false, sortDirection: "desc", class: "title" }
  ];

  get _value(): Array<UnReadNotificationTableItem> {
    return this.value;
  }

  /**
   * ### お知らせ押下イベント
   */
  public onNotification(notification: UnReadNotificationTableItem): void {
    this.$emit("onNotification", notification);
    return;
  }
}

/** テーブルの列名の情報 */
export interface UnReadNotificationTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface UnReadNotificationTableItem {
  id: number;
  text: string;
  title: string;
  deleteFlag: boolean;
  startPublish: number;
  endPublish: number;
  required: boolean;
  created: number;
  updated: number;
  date: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.notification-table-component {
  .title {
    .detail-link {
      margin-right: 8px;
      word-break: break-all;
    }
    .new {
      min-width: 36px;
      @include validation-label();
    }
  }
}
</style>
